import React from "react";
import PropTypes from 'prop-types'
import Icon from "@material-ui/core/Icon";
import formatValue from "../../../../../../Utils/ListUtils/FormatValue";

const Message = ({initiator, initiatorName, dateTime, text, currentUserId, ourUser}) => {
    const isOwnMessage = (initiatorName || initiator) === (ourUser || currentUserId);
    const wrapperStyles = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: isOwnMessage ? 'flex-end' : 'flex-start'
    };
    const messageInfoStyles = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: isOwnMessage ? 'flex-end' : 'start'
    };
    const messageTextStyles = {
        textAlign: 'left',
        borderRadius: isOwnMessage ? "10px 10px 0 10px" : "0 10px 10px 10px",
        background: isOwnMessage ? '#c7e4fa' : '#e3f1fd',
        maxWidth: isOwnMessage ? '80%' : '90%',
        padding: 7,
        margin: "0 5px 5px",
        wordBreak: 'break-word'
    };
    const userInfoStyles = {
        padding: isOwnMessage ? '0 7px 0 0' : '0 0 0 5px',
        fontSize: 12,
        color: "#b4b4b4"
    };
    const iconStyles = {
        height: 30,
        width: 30,
        alignSelf: 'end',
        margin: '5px 0',
        padding: '0 5px 0px',
        color: '#717171'
    };
    return (
        <div style={{...wrapperStyles}}>
            {!isOwnMessage && (<Icon style={{...iconStyles}}>account_circle</Icon>)}
            <div style={{...messageInfoStyles}}>
                <span style={{...userInfoStyles}}>
                    {isOwnMessage ?
                        <span>{formatValue(dateTime, 'datetime', null)}</span> :
                        <span>{initiatorName || initiator}, {formatValue(dateTime, 'datetime', null)}</span>}
                </span>
                <div style={{...messageTextStyles}}>
                    {text}
                </div>
            </div>
        </div>
    )
};

Message.propTypes = {
    initiator: PropTypes.string,
    time: PropTypes.string,
    text: PropTypes.string,
    currentUserId: PropTypes.string
};

Message.defaultProps = {
    initiator: ""
};

export default Message;